'use client'

import { Cell, Icon, Text, Spacer, Divider } from '@vinted/web-ui'
import { Fire24 } from '@vinted/monochrome-icons'
import { useInView } from 'react-intersection-observer'

import {
  ItemPageHighDemandSignalInfoPluginModel,
  itemPageViewEvent,
} from '@marketplace-web/item-page/item-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

const ItemPageHighDemandSignalInfoPlugin = ({
  title,
  itemId,
  pluginName,
}: ItemPageHighDemandSignalInfoPluginModel & { pluginName: string }) => {
  const { track } = useTracking()

  const { ref } = useInView({
    onChange: inView => {
      if (!inView) return
      track(
        itemPageViewEvent({
          item_id: itemId.toString(),
          target: 'high_demand',
        }),
      )
    },
    triggerOnce: true,
  })

  return (
    <div ref={ref}>
      <Spacer size={Spacer.Size.Large} />
      <Divider orientation={Divider.Orientation.Horizontal} />
      <Spacer size={Spacer.Size.Large} />
      <Cell
        prefix={<Icon name={Fire24} color={Icon.Color.Warning} />}
        title={<Text as="span" text={title} html type={Text.Type.Subtitle} theme="amplified" />}
        styling={Cell.Styling.Tight}
        testId={pluginName}
      />
      <Spacer size={Spacer.Size.Regular} />
    </div>
  )
}

export default ItemPageHighDemandSignalInfoPlugin
